import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowLeft, Award, Loader2 } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { MainLayout } from '../components/layout/MainLayout';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { CertificateView } from '../components/certificate/CertificateView';
import { courseCertificate } from '../components/certificate/certificateContent';
import { builderCertificatePath } from '../components/course-builder/certificateLinks';

// Certificates from the original course library (looked up by id); course builder ones redirect to their own page
export default function LegacyCertificatePage({ program, backTo }) {
  const { certificateId } = useParams();
  const { api, user } = useAuth();
  const navigate = useNavigate();
  const [state, setState] = useState({ loading: true, cert: null, error: null });

  useEffect(() => {
    let live = true;
    api.get(`/tech-learning/certificates/${certificateId}`)
      .then((r) => {
        const cert = r.data.certificate;
        const builderPath = builderCertificatePath(cert);
        if (builderPath) navigate(builderPath, { replace: true });
        else if (live) setState({ loading: false, cert, error: null });
      })
      .catch((e) => live && setState({ loading: false, cert: null, error: e.response?.data?.detail || 'Certificate not found' }));
    return () => { live = false; };
  }, [api, certificateId, navigate]);

  const { loading, cert, error } = state;
  return (
    <MainLayout>
      <div className="mx-auto max-w-5xl space-y-6" data-testid="legacy-certificate-page">
        <Button variant="ghost" onClick={() => navigate(backTo)} data-testid="legacy-certificate-back">
          <ArrowLeft className="mr-2 h-4 w-4" />Back to my courses
        </Button>
        {loading ? (
          <div className="flex h-96 items-center justify-center"><Loader2 className="h-8 w-8 animate-spin text-primary" /></div>
        ) : error ? (
          <Card data-testid="certificate-unavailable">
            <CardContent className="flex flex-col items-center py-16 text-center">
              <Award className="h-14 w-14 text-muted-foreground/50" />
              <h2 className="mt-4 font-heading text-xl font-semibold">Certificate not available</h2>
              <p className="mt-1 text-muted-foreground">{error}</p>
            </CardContent>
          </Card>
        ) : (
          <CertificateView data={courseCertificate({ ...cert, program: cert.program || program }, user?.id === cert.user_id ? user.email : undefined)} />
        )}
      </div>
    </MainLayout>
  );
}
